export default __webpack_public_path__ + "static/media/agneauEntier.869acba7.jpg";